import * as React from "react";
import { makeStyles, Button } from "@fluentui/react-components";

const useStyles = makeStyles({
  wrapper: {
    columnGap: "15px",
    display: "flex",
    justifyContent: "end"
  },
});

const TransparentButton = (props) => {
  const { label, handleClick } = props;
  const styles = useStyles();
  
  return (
    <div className={styles.wrapper} onClick={handleClick}>
      <Button className="text-xsm-400 font-family-imp" appearance="transparent" size="small">
        {label}
      </Button>
    </div>
  );
};

export default TransparentButton;